if (!customElements.get("custom-video")) {
    class CustomVideo extends HTMLElement {
        constructor() {
            super();
            if (this?.dataset?.options) {
                this.options = JSON.parse(this.dataset.options)
            }
            this.links = this.querySelectorAll("a");
            this.video = this.querySelector("video");
            this.videoTriggers = this.querySelectorAll("[data-video-trigger]");
            this.videoWrapper = this.closest("[data-video-wrapper]");
            this.overlayImage = this.videoWrapper.querySelector("[data-video-overlay-image]");
            this.overlayMobImage = this.videoWrapper.querySelector("[data-video-overlay-image-mobile]");
            this.overlayText = this.videoWrapper.querySelector("[data-video-text-overlay]");
            this.videoTriggers?.forEach((trigger => trigger.addEventListener("click", this.loadVideo.bind(this))));
            this.video.addEventListener("click", this.loadVideo.bind(this));
            this.links?.forEach((link => link.addEventListener("click", (function(event) {
                event.stopImmediatePropagation()
            }))));
            this.breakpoints = breakpoints();
            this.breakPointName = this.breakpoints[this.options.video_breakpoint][0];
            this.breakPointSize = this.breakpoints[this.options.video_breakpoint][1];
            this.debouncedOnLoad = debounce((event => {
                this.videoObserver(event)
            }), 100);
            if (this.options.autoplay) {
                if (this.closest(".swiper-slide") !== null) {
                    if (this.closest(".swiper-slide-active") != null) {
                        this.playVideo()
                    } else {
                        this.pauseVideo()
                    }
                }
                window.addEventListener("scroll", this.debouncedOnLoad.bind(this));
                window.addEventListener("load", this.debouncedOnLoad.bind(this));
                window.addEventListener("resize", this.debouncedOnLoad.bind(this))
            }
        }
        videoObserver(event) {
            const observer = new IntersectionObserver((entries => {
                entries.forEach((entry => {
                    const elementBounds = entry.boundingClientRect;
                    const isSlideLeft = !!elementBounds.left == 0;
                    const isBottomVisible = !!(elementBounds.bottom < window.innerHeight) && elementBounds.bottom;
                    const isTopVisible = !!(elementBounds.top > 0) && elementBounds.top;
                    if (this.options.autoplay) {
                        this.playVideo()
                    } else {
                        if (!this.video.paused) {
                            this.pauseVideo()
                        }
                    }
                    if (this.options.mp4_desktop && this.options.mp4_mobile) {
                        this.observedVideoCallback(entry.target, isBottomVisible, isTopVisible, isSlideLeft)
                    } else if (this.options.mp4_desktop && !this.options.mp4_mobile && window.innerWidth >= this.breakPointSize && this.parentNode.classList.contains(`visibility-${this.breakPointName}--visible`)) {
                        this.observedVideoCallback(entry.target, isBottomVisible, isTopVisible, isSlideLeft)
                    } else if (!this.options.mp4_desktop && this.options.mp4_mobile && window.innerWidth < this.breakPointSize && this.parentNode.classList.contains(`visibility-${this.breakPointName}--hidden`)) {
                        this.observedVideoCallback(entry.target, isBottomVisible, isTopVisible, isSlideLeft)
                    }
                }))
            }));
            if (this.video.dataset.videoIsPaused !== "true") {
                observer.observe(this.video)
            }
        }
        observedVideoCallback(target, isBottomVisible, isTopVisible, isSlideLeft) {
            if (target.closest(".swiper-slide") !== null) {
                if (isBottomVisible && isTopVisible && isSlideLeft) {
                    this.playVideo()
                }
            } else if (isBottomVisible && isTopVisible) {
                this.playVideo()
            } else {
                this.pauseVideo()
            }
        }
        loadVideo(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.video.paused) {
                this.playVideo();
                this.video.dataset.videoIsPaused = "false"
            } else {
                this.pauseVideo();
                this.video.dataset.videoIsPaused = "true"
            }
        }
        playVideo() {
            if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
                this.overlayMobImage?.classList.add("hidden")
            }
            this.overlayImage?.classList.add("hidden");
            this.overlayText?.classList.add("hidden");
            this.videoTriggers[0]?.classList.add("hidden");
            this.video.play()
        }
        pauseVideo() {
            if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
                this.overlayMobImage?.classList.remove("hidden")
            }
            this.overlayImage?.classList.remove("hidden");
            this.overlayText?.classList.remove("hidden");
            this.videoTriggers[0]?.classList.remove("hidden");
            this.video.pause()
        }
    }
    window.CustomVideo = CustomVideo;
    customElements.define("custom-video", CustomVideo)
}
//# sourceMappingURL=custom-video.js.map